import OmbudsmanHome from "components/Ombudsman/OmbudsmanHome";
import OmbudsmanBanner from "components/Ombudsman/OmbudsmanBanner/OmbudsmanBanner";

const Ombudsman = () => {
  return (
    <article className="make-section" data-section="ouvidoria page">
      <OmbudsmanBanner />
      <OmbudsmanHome />
    </article>
  );
};

export default Ombudsman;
